import { configureStore } from "@reduxjs/toolkit";
import getVocabularyForm from "./slice/VocabularyFormSlice";
import packageManagerReducer from "./slice/PackageManger";
import contentReducer from "./slice/ContentSlice";
import selectClassReducer from "./slice/SelectClassSlice";
import StudentDetailReducer from "./slice/StudentDetailSlice";
import activeComponentReducer from "./slice/ActiveComponentSlice";
import scoreReducer from "./slice/ScoreSlice";
import ContentArrayReducer from "./slice/ContentArraySlice";
import activeChapterReducer from "./slice/ActiveChapterSlice";
import classActiveReducer from "./slice/ClassAcitveSlice";
import extraResucer from "./slice/ExtraSilce";
import extraLessonReducer from "./slice/extralessonSlice";
import extraLessonTaskReducer from "./slice/extraLessonTaskSlice";
import activeSectionReducer from "./slice/ActiveSectionSlice";
export const store = configureStore({
  reducer: {
    VocabularyForm: getVocabularyForm,
    packageManager: packageManagerReducer,
    contents: contentReducer,
    selectClass: selectClassReducer,
    studentDetailId: StudentDetailReducer,
    activeComponent: activeComponentReducer,
    score: scoreReducer,
    contentArray: ContentArrayReducer,
    chapterValue: activeChapterReducer,
    classActive: classActiveReducer,
    extra: extraResucer,
    lesson: extraLessonReducer,
    extralessanTask: extraLessonTaskReducer,
    section: activeSectionReducer,
  },
});
